export default "__VITE_ASSET__DLItsocT__"